import { FlashMessageThemeEnum } from '@/js/enums/FlashMessageThemeEnum';
import { useNotification } from '@kyvg/vue3-notification';
import { Ref } from 'vue';

const { notify } = useNotification();

export const flashMessage = (type: FlashMessageThemeEnum, title: string | Ref, text?: string | Ref, group?: 'bottom-right' | 'top-right'): void => {
    notify({
        group: group ?? 'bottom-right',
        title: title,
        text: text,
        duration: type === FlashMessageThemeEnum.Error ? 5000 : 3000,
        data: {
            theme: type,
        },
    });
};
